/* eslint-disable max-len */
// --- React components init on Listing page
import initCompareBlock from '../components/react/Compare/initCompareBlock.jsx';
import initComparePopup from '../components/react/ComparePopup/initComparePopup.jsx';
import initViewSwitch from '../components/react/ListingPage/initViewSwitch.jsx';
import initItemsPerPageCount from '../components/react/ListingPage/initItemsPerPageCount.jsx';
import initSortBy from '../components/react/ListingPage/initSortBy.jsx';
import initProductListing from '../components/react/ListingPage/initProductListing.jsx';
import initSponsoredProducts from '../components/react/ListingPage/initSponsoredProducts.jsx';
import initPaginator from '../components/react/ListingPage/initPaginator.jsx';
import initPageTitle from '../components/react/ListingPage/initPageTitle';
import initBanners from '../components/react/ListingPage/initBanners';
import initFilters from '../components/react/ListingPage/initFilters';
import initProductListingResultsMessage from
  '../components/react/ListingPage/initProductListingResultsMessage.jsx';
import {
  setCategory, setCountdownClassSuffix,
  setSortByOptions, setViewSwitch, setLocationSearchEnabled
} from '../appState/ducks/listingPageSetup';
import { setHeaderBanner } from '../appState/ducks/listingPageBanners';
import {
  setPaginationPageList,
  setPaginationItemsNumberPerPage,
  setPaginationResultsMessage
} from '../appState/ducks/listingPagePagination';
import { setFiltersSetup } from '../appState/ducks/listingPageFilters';
import { prepareFiltersPayload }
  from '../components/react/ListingPage/components/Filtering/filterHelpers';

import { addLocationSearchToProductListView } from '../components/productlistviewExtender'; // eslint-disable-line no-unused-vars

import initAddedValueMessagesListing from
  '../components/react/ListingPage/initAddedValueMessagesListing.jsx';

import initTariffDetailsListing from '../components/react/ListingPage/initTariffDetailsListing';

import initLocationSearchForAjax from '../components/react/ListingPage/initLocationSearch';
import { initSliders } from '../components/dc-slider.js';

// --- Other utils
const globalInit = require('./global.js');
const listingPageFiltering = require('../listing-page-filtering.js');
const ProductsViewGrid = require('../components/productsView/productsViewGrid');
const oosEmail = require('../email-oos');

const UISettings = require('../utils/UISettings.js');
const UIProductListView = require('../components/productlistview');
const LocationService = require('../locationservice');
const initNeedsClick = require('../ui/needs-click.js');
const sticky = require('../sticky.js');

function createProductListView() {

  const productView = new UIProductListView();

  // correct wrong special characters in products marketing messages
  $('article .desc .rad i ~ strong').each((i, element) => {
    $(element).html($(element).text());
  });

  // init of location search components for product view
  const listingPageAjaxActive = UISettings.get('component.listing-page-products.ajax-enabled');

  if (!listingPageAjaxActive || listingPageAjaxActive === false) {
    UISettings.watchChanges('groupcallIsLoading', UISettings.Type.USER, initLocationSearch);
    initLocationSearch(UISettings.get('groupcallIsLoading', UISettings.Type.USER));

    if (document.querySelector('[data-component="locationsearch"]')) {
      addLocationSearchToProductListView(productView);
    }
  } else {
    initLocationSearchForAjax();
  }

  return productView;
}

function initLocationSearch(groupcallIsLoading) {
  if (groupcallIsLoading) {
    return;
  }
  LocationService.load();
}

function loadJsonLinkedDataSetup() {
  const dispatch = window.appState.dispatch;
  const ajaxSettings =
    UISettings.get('component.listing-page-products.ajax-settings');

  dispatch(setCountdownClassSuffix(ajaxSettings.countdownClassSuffix));
  dispatch(setSortByOptions(ajaxSettings.sortByOptions));
  dispatch(setViewSwitch(ajaxSettings.viewSwitch));
  dispatch(setLocationSearchEnabled(
    Boolean(ajaxSettings.stockChecker && ajaxSettings.stockChecker.isLocationSearchEnabled)
  ));
  dispatch(setPaginationItemsNumberPerPage(ajaxSettings.pagination.itemsNumberPerPage));
  dispatch(setFiltersSetup(prepareFiltersPayload(
    ajaxSettings.filters,
    /* firstPageLoad = */ true
  )));
  dispatch(setHeaderBanner(ajaxSettings.banner));
  dispatch(setPaginationResultsMessage(ajaxSettings.pagination.showingResultsLabel));

  // Ajax list page is not implemented for search listing page,
  // so there is no necessary use pagination page list init which is used only for Ajax listing page
  if (window.digitalData.page.category.universe !== 'search results page') {
    dispatch(setPaginationPageList(ajaxSettings.pagination.pageList));
  }

  // Category data are not loaded from ajax-settings because we already had them in digitalData.
  dispatch(setCategory(window.digitalData.page.category));
}

let productsViewGrid = null;

const listingPageInit = {
  DOMReadyInit: function DOMReadyInit() {
    listingPageFiltering.initListingPageFiltering();
    const productViewList = createProductListView();

    // Redux structure should be prepared before all react components are initialized below.
    loadJsonLinkedDataSetup();

    // Sort by panel including 3 components (ViewSwitch, SortBy, ListView switcher)
    initViewSwitch();
    initSortBy();
    initItemsPerPageCount();

    // Ajax Products listing with paginator and filters.
    const listingPageAjaxActive = UISettings.get('component.listing-page-products.ajax-enabled');
    if (listingPageAjaxActive && listingPageAjaxActive === true) {
      initPaginator();
      initProductListing();
      initProductListingResultsMessage();
      initFilters();
      initPageTitle();
      initBanners();
    }

    // Compare panel and compare checkboxes
    const comparePanel = document.querySelector('[data-component="compare-panel"]');
    if (comparePanel) {
      initCompareBlock(comparePanel, false);
      sticky.initialiseCompare('[data-component="compare-panel"]');
    }
    // Compare pop up
    const comparePanelPopup = document.querySelector('[data-component="compare-panel-popup"]');
    if (comparePanelPopup) {
      initComparePopup(comparePanelPopup);
    }

    // init sponsored products
    initSponsoredProducts(productsViewGrid, productViewList);

    // init tariff details
    initTariffDetailsListing();

    // Added value messaging
    initAddedValueMessagesListing();
    initSliders();
  },
  init: function init() {
    productsViewGrid = new ProductsViewGrid();
    oosEmail.initFormSubmit('.email-when-back-form', productsViewGrid);
    initNeedsClick();
  }
};
globalInit.initPage(listingPageInit);
